export default __webpack_public_path__ + "static/media/hht1_storybook_17.0b1868aa.png";